import i18n from "../LanguageSelector/i18n";

export const profileItems = [
  {
    get label() {
      return i18n.t("general.firstname");
    },
    id: "firstname",
  },
  {
    get label() {
      return i18n.t("general.lastname");
    },
    id: "lastname",
  },
  {
    get label() {
      return i18n.t("general.email");
    },
    id: "email",
  },
  {
    get label() {
      return i18n.t("general.phone");
    },
    id: "phone",
  },
];
export const companyItems = [
  {
    get label() {
      return i18n.t("general.name");
    },
    id: "companyname",
  },
  {
    get label() {
      return i18n.t("general.city");
    },
    id: "city",
  },
  {
    get label() {
      return i18n.t("general.street");
    },
    id: "street",
  },
  {
    get label() {
      return i18n.t("general.postcode");
    },
    id: "postcode",
  },
];
export const notificationPreferences = [
  {
    get label() {
      return i18n.t("general.location");
    },
    id: "location",
  },
  {
    get label() {
      return i18n.t("general.payment");
    },
    id: "payment",
  },
  {
    get label() {
      return i18n.t("general.msg");
    },
    id: "message",
  },
  {
    get label() {
      return i18n.t("general.marketing");
    },
    id: "marketing",
  },
];

export const menuItems = [
  { label: "Dashboard", classN: "MenuItem", main: true },
  { label: "Shipments", classN: "MenuItem", main: true },
  { label: "Proposals", classN: "MenuItem", main: true },
  { label: "Profile", classN: "MenuItem", main: true },
  { label: "Support", classN: "MenuItem", main: true },
  { label: "New Order", classN: "MenuItem", main: true },
];

export const menuItemsAdmin = [
  { label: "Orders", classN: "MenuItem", main: true },
  { label: "Customers", classN: "MenuItem", main: true },
  { label: "Support", classN: "MenuItem", main: true },
];

export const menuItemsDocuments = [
  { label: "Import Customs Clearance", classN: "MenuItem", main: true },
  { label: "Export Customs Clearance", classN: "MenuItem", main: true },
  /*  { label: "Customs Direct Representation", classN: "MenuItem", main: true }, */
];

export const headingItemsManageOrder = [
  {
    get label() {
      return i18n.t("matable.shipmentnr");
    },
    id: "_id",
    type: "string",
  },
  {
    get label() {
      return i18n.t("matable.date");
    },
    id: "datecreated",
    type: "string",
  },
  {
    get label() {
      return i18n.t("matable.completereq");
    },
    id: "complete",
    type: "checkbox",
  },
  {
    get label() {
      return i18n.t("matable.paid");
    },
    id: "payment",
    type: "dropdown",
  },
  {
    get label() {
      return i18n.t("matable.active");
    },
    id: "active",
    type: "checkbox",
  },
];

export const controlItems = [
  {
    get label() {
      return i18n.t("statuses.pickedup");
    },
    value: "pickedup",
  },
  {
    get label() {
      return i18n.t("statuses.origin");
    },
    value: "origin",
  },
  {
    get label() {
      return i18n.t("statuses.intransit");
    },
    value: "transit",
  },
  {
    get label() {
      return i18n.t("statuses.destination");
    },
    value: "destination",
  },
  {
    get label() {
      return i18n.t("statuses.consignee");
    },
    value: "delivered",
  },
];

export const orderLabels = {
  payment: {
    get open() {
      return i18n.t("matable.open");
    },
    get paid() {
      return i18n.t("matable.paid");
    },
    get overdue() {
      return i18n.t("matable.overdue");
    },
    get ""() {
      return i18n.t("matable.processing");
    },
  },
  proposalstatus: {
    get ""() {
      return i18n.t("matable.processing");
    },
    get processing() {
      return i18n.t("matable.processing");
    },
    get open() {
      return i18n.t("matable.open");
    },
    get accepted() {
      return i18n.t("matable.accepted");
    },
    get declined() {
      return i18n.t("matable.declined");
    },
  },
};

export const dropdownItemsFilter = [
  {
    get label() {
      return i18n.t("filters.complete");
    },
    id: "complete",
    options: [
      {
        get option() {
          return i18n.t("general.yes");
        },
        value: true,
      },
      {
        get option() {
          return i18n.t("general.no");
        },
        value: false,
      },
      {
        get option() {
          return i18n.t("matable.nofilter");
        },
        value: "",
      },
    ],
  },
  {
    get label() {
      return i18n.t("filters.quotesent");
    },
    id: "quotesent",
    options: [
      {
        get option() {
          return i18n.t("general.yes");
        },
        value: true,
      },
      {
        get option() {
          return i18n.t("general.no");
        },
        value: false,
      },
      {
        get option() {
          return i18n.t("matable.nofilter");
        },
        value: "",
      },
    ],
  },
  {
    get label() {
      return i18n.t("filters.accepted");
    },
    id: "proposalstatus",
    options: [
      {
        get option() {
          return i18n.t("general.yes");
        },
        value: true,
      },
      {
        get option() {
          return i18n.t("general.no");
        },
        value: false,
      },
      {
        get option() {
          return i18n.t("matable.nofilter");
        },
        value: "",
      },
    ],
  },
  {
    get label() {
      return i18n.t("filters.paid");
    },
    id: "payment",
    options: [
      {
        get option() {
          return i18n.t("matable.open");
        },
        value: "open",
      },
      {
        get option() {
          return i18n.t("matable.paid");
        },
        value: "paid",
      },
      {
        get option() {
          return i18n.t("matable.overdue");
        },
        value: "overdue",
      },
      {
        get option() {
          return i18n.t("matable.nofilter");
        },
        value: "",
      },
    ],
  },
  {
    get label() {
      return i18n.t("filters.active");
    },
    id: "active",
    options: [
      {
        get option() {
          return i18n.t("matable.yes");
        },
        value: true,
      },
      {
        get option() {
          return i18n.t("matable.no");
        },
        value: false,
      },
      {
        get option() {
          return i18n.t("matable.nofilter");
        },
        value: "",
      },
    ],
  },
];

export const inputItemsFilter = [
  {
    get placeholder() {
      return i18n.t("matable.shipmentnr");
    },
    id: "_id",
  },
  { placeholder: "yyyy-MM-dd", id: "datecreated" },
  {
    get placeholder() {
      return i18n.t("general.name");
    },
    id: "clientname",
  },
];

export const chargeInputs = [
  {
    get label() {
      return i18n.t("quotation.chargename");
    },
    id: "chargename",
  },
  {
    get label() {
      return i18n.t("quotation.carrier");
    },
    id: "carrier",
  },
  {
    get label() {
      return i18n.t("quotation.unitofmeasurement");
    },
    id: "unit",
  },
  {
    get label() {
      return i18n.t("quotation.densityratio");
    },
    id: "density",
  },
  {
    get label() {
      return i18n.t("quotation.currency");
    },
    id: "currency",
  },
  {
    get label() {
      return i18n.t("quotation.rate");
    },
    id: "rate",
  },
  {
    get label() {
      return i18n.t("quotation.total");
    },
    id: "total",
  },
];

export const freightChargeObject = {
  chargename: "",
  carrier: "",
  unit: "",
  density: "",
  currency: "",
  rate: 0,
  total: 0,
};

export const chargeObject = {
  chargename: "",
  unit: "",
  density: "",
  currency: "",
  rate: 0,
  total: 0,
};

export const Dimensions = [
  {
    get label() {
      return i18n.t("general.length");
    },
    id: "length",
  },
  {
    get label() {
      return i18n.t("general.width");
    },
    id: "width",
  },
  {
    get label() {
      return i18n.t("general.height");
    },
    id: "height",
  },
  {
    get label() {
      return i18n.t("general.weight");
    },
    id: "weight",
  },
  {
    get label() {
      return i18n.t("general.quantity");
    },
    id: "quantity",
  },
];

export const AddressInputs = [
  {
    get label() {
      return i18n.t("general.companylabel");
    },
    id: "companyname",
    width: "100%",
  },
  {
    get label() {
      return i18n.t("general.country");
    },
    id: "country",
    width: "100%",
  },
  {
    get label() {
      return i18n.t("general.city");
    },
    id: "city",
    width: "47%",
  },
  {
    get label() {
      return i18n.t("general.postcode");
    },
    id: "postcode",
    width: "47%",
  },
  {
    get label() {
      return i18n.t("general.address");
    },
    id: "address",
    width: "100%",
  },
];

export const ContactInputs = [
  {
    get label() {
      return i18n.t("general.firstname");
    },
    id: "firstname",
    width: "47%",
  },
  {
    get label() {
      return i18n.t("general.lastname");
    },
    id: "lastname",
    width: "47%",
  },
  {
    get label() {
      return i18n.t("general.email");
    },
    id: "email",
    width: "100%",
  },
  {
    get label() {
      return i18n.t("general.phone");
    },
    id: "phone",
    width: "100%",
  },
];

export const messageColumnsDashboard = [
  {
    get title() {
      return i18n.t("matable.threadid");
    },
    field: "threadIDShort",
    align: "left",
    render: (rowData) => {
      return (
        <span className={!rowData.seen ? "Bold" : ""}>
          {rowData.threadIDShort}
        </span>
      );
    },
  },
  {
    get title() {
      return i18n.t("matable.sent");
    },
    field: "sent",
    align: "left",
    defaultSort: "desc",
    render: (rowData) => {
      return (
        <span className={!rowData.seen ? "Bold" : ""}>{rowData.sent}</span>
      );
    },
  },
  {
    get title() {
      return i18n.t("matable.msg");
    },
    field: "message",
    align: "left",
    render: (rowData) => {
      return (
        <span className={!rowData.seen ? "Bold" : ""}>{rowData.message}</span>
      );
    },
  },
];

export const ordersColumns = [
  {
    get title() {
      return i18n.t("matable.date");
    },
    field: "datecreated",
    align: "left",
    defaultSort: "desc",
  },
  {
    get title() {
      return i18n.t("matable.shipmentnr");
    },
    field: "_id",
    align: "left",
  },
  {
    get title() {
      return i18n.t("matable.milestone");
    },
    field: "statuslabel",
    align: "left",
  },
  {
    get title() {
      return i18n.t("matable.payment");
    },
    field: "paymentlabel",
    align: "left",
  },
];

export const proposalsColumns = [
  {
    get title() {
      return i18n.t("matable.date");
    },
    field: "datecreated",
    align: "left",
    defaultSort: "desc",
  },
  {
    get title() {
      return i18n.t("matable.shipmentnr");
    },
    field: "_id",
    align: "left",
  },
  {
    get title() {
      return i18n.t("matable.status");
    },
    field: "proposalstatuslabel",
    align: "left",
  },
  {
    get title() {
      return i18n.t("matable.proposal");
    },
    field: "proposal",
    align: "center",
  },
  {
    title: "",
    field: "buttons",
    align: "left",
  },
];

export const userSupportColumns = [
  {
    get title() {
      return i18n.t("matable.threadid");
    },
    field: "threadID",
    align: "left",
    customSort: (a, b) => parseInt(a.threadID) - parseInt(b.threadID),
    render: (rowData) => {
      return (
        <span className={!rowData.seen ? "Bold" : ""}>{rowData.threadID}</span>
      );
    },
  },
  {
    get title() {
      return i18n.t("matable.sent");
    },
    field: "sent",
    align: "left",
    defaultSort: "desc",
    render: (rowData) => {
      return (
        <span className={!rowData.seen ? "Bold" : ""}>{rowData.sent}</span>
      );
    },
  },
  {
    get title() {
      return i18n.t("matable.msg");
    },
    field: "message",
    align: "left",
    render: (rowData) => {
      return (
        <span className={!rowData.seen ? "Bold" : ""}>{rowData.message}</span>
      );
    },
  },
];

export const adminOrdersColumns = [
  {
    get title() {
      return i18n.t("matable.shipmentnr");
    },
    field: "_id",
    align: "left",
  },
  {
    get title() {
      return i18n.t("matable.date");
    },
    field: "datecreated",
    align: "left",
    defaultSort: "desc",
  },
  {
    get title() {
      return i18n.t("matable.clientname");
    },
    field: "clientname",
    align: "left",
  },
  {
    get title() {
      return i18n.t("matable.completereq");
    },
    field: "completelabel",
    align: "left",
  },
  {
    get title() {
      return i18n.t("matable.quotesent");
    },
    field: "quotedate",
    align: "left",
  },
  {
    get title() {
      return i18n.t("matable.accepted");
    },
    field: "proposalstatuslabel",
    align: "left",
  },
  {
    get title() {
      return i18n.t("matable.paid");
    },
    field: "paymentlabel",
    align: "left",
  },
  {
    get title() {
      return i18n.t("matable.active");
    },
    field: "activelabel",
    align: "left",
  },
];

export const menuLabels = {
  get Dashboard() {
    return i18n.t("dashboardmenu.dashboard");
  },
  get Orders() {
    return i18n.t("dashboardmenu.orders");
  },
  get Proposals() {
    return i18n.t("dashboardmenu.proposals");
  },
  get Customers() {
    return i18n.t("dashboardmenu.customers");
  },
  get Shipments() {
    return i18n.t("dashboardmenu.shipments");
  },
  get Profile() {
    return i18n.t("dashboardmenu.profile");
  },
  get Support() {
    return i18n.t("dashboardmenu.support");
  },
  get "Import Customs Clearance"() {
    return "Import Customs Clearance";
  },
  get "Export Customs Clearance"() {
    return "Export Customs Clearance";
  },
  get "Customs Direct Representation"() {
    return "Customs Direct Representation";
  },
  get "New Order"() {
    return i18n.t("dashboardmenu.neworder");
  },
};

export const quotationOtherCharges = [
  {
    label: "Raktározás/Warehousing BUD",
    content:
      "Érkezés + 2 munkanap ingyenes, utána EUR 5/csomag/nap / Arrival+2 days free of charge, after EUR 5/colli/day",
  },
  {
    label: "Dokumentum módosítás / Document amendment",
    content:
      "dokumentum módosítás 10 EUR/küldemény /document modification  10 EUR/shipment				",
  },
  {
    label:
      "Áru átcsomagolása hőkezelt palettára/ Repacking with fumigated pallet",
    content: "EUR 70 or/vagy HUF 20000 per palett",
  },
  {
    label: "Heavy lifting equipment fee	",
    content: "1000 kg/ db felett EUR 10/db /  above 1000kg/piece EUR 10/piece",
  },
  {
    label: "Vámszemle díja / Customs inspection (per case)",
    content: "10000 HUF / 30 EUR",
  },
  {
    label:
      "Állásdíi  helyi kiszállításnál vagy árufelvételnél a kocsik várakoztatása esetén:	",
    content: "5000 HUF/óra, 3. megkezdett óra után",
  },
  {
    label: "Vámkezelés további sorok / Customs Clearance additional rows",
    content:
      "Vámokmány 3. sor után + 1600 Ft vagy 5 EUR vagy 6 USD a plusz sorokra az alapdíjon felül / Customs clearance after Line 3 +1600 HUF or EUR 5 or USD 6 per Line Item",
  },
];

export const quotationImportantNotes = [
  {
    content:
      'Üzleteinket az általános magyar szállítási feltételek szerint bonyolítjuk. Ajánlatunk az Unicredit Bank számlázás napjára vonatkozó árfolyamán érvényes.',
  },
  {
    content:
      'Az üzemanyag és biztonsági felár terjedelemsúly alapján kerül felszámolásra és külön értesítés nélkül változhat.',
  },
  {
    content:
      'Az árak a vámkezelést követő munkanapon való kiszállításra érvényesek (korábbi kiszállítás esetén sűrgősségi felár fizetendő)',
  },
  {
    content: 'A fenti árak az ÁFA-t nem tartalmazzák.',
  },
  {
    content:
      'A díjszámítás alapja 1 m3= min. 167 kg, az árak minden esetben azzal a sávval kerülnek kiszabásra amely súly határba a szállítmány díjszámítási súlya esik',
  },
  {
    content:
      'A számlázás HUF ban történik amennyiben az ügyfél másként nem rendelkezik',
  },
  {
    content:
      'Az ajánlatban feltüntetett tranzit idő tájékoztató jellegű, az esetleges eltérésekért anyagi felelősséget nem áll módunkban vállalni!',
  },
  {
    content:
      'Az első három küldemény esetén a SKYU kérheti a teljesítés előtti számla kiegyenlítést.',
  },
  {
    content:
      'A számlázandó fuvardíj eltérhet a csatolt árajánlatétól, mivel a mindenkori fuvarlevélen szereplő – tényleges – árumennyiség alapján véglegesítjük.',
  },
];

export const quotationRemarks = [
  {
    content:
      "All work undertaken in accordance with Hungarian General Conditions of Transportation. ",
  },
  {
    content:
      "Our quotation is valid on the official exchange rate of National Bank of Hungary on the day of invoicing.",
  },
  {
    content:
      "Fuel and security surcharges are calculated on the basis of chargable weight . Surcharges  are subject to change without prior notice.",
  },
  {
    content: "Total amount does not include VAT.",
  },
  {
    content: "Prepaid condition can be applied at the 3 first shipment.",
  },
  {
    content:
      "Airfreight rate is calculated on the basis of the actual or volumetric weight (1m3=min.167 kg), whichever is greater.",
  },
  {
    content:
      "Estimated transit time in the quote does not mean financial liability in case of delay",
  },
];
